import type { SVGProps } from 'react'
const SvgSyCheckRingRound = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={8} fillOpacity={0.24} />
		<path d="M15.076 9.576 11.5 13.15l-1.576-1.574-.848.848 1.893 1.894a.76.76 0 0 0 1.062 0l3.893-3.894z" />
		<path d="M12 4a8.002 8.002 0 0 0-1.56 15.846 8 8 0 0 0 8.213-3.4A8 8 0 0 0 20 12a.5.5 0 0 0-.5-.5.5.5 0 0 0-.5.5 6.999 6.999 0 1 1-7-7 .5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5" />
	</svg>
)
export default SvgSyCheckRingRound
